import { Calendar } from "lucide-react";
import { toast } from "sonner";
import { format } from "date-fns";

export const CalendarButton = ({ launch, className = "" }) => {
  const generateICS = () => {
    if (!launch.net) {
      toast.error("Launch date not confirmed yet");
      return;
    }

    const startDate = new Date(launch.net);
    const endDate = new Date(startDate.getTime() + 2 * 60 * 60 * 1000); // 2 hours duration

    const formatICSDate = (date) => {
      return date.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
    };

    const icsContent = `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Florida Launch Tracker//EN
BEGIN:VEVENT
UID:${launch.id}@floridalaunches.com
DTSTAMP:${formatICSDate(new Date())}
DTSTART:${formatICSDate(startDate)}
DTEND:${formatICSDate(endDate)}
SUMMARY:${launch.name}
DESCRIPTION:${launch.mission_description || "Rocket launch from Florida"}\\n\\nRocket: ${launch.rocket}\\nLocation: ${launch.pad_name}\\n${launch.webcast ? "Watch: " + launch.webcast : ""}
LOCATION:${launch.location_name || launch.pad_name}
STATUS:${launch.status?.toLowerCase().includes("go") ? "CONFIRMED" : "TENTATIVE"}
END:VEVENT
END:VCALENDAR`;

    // Create and download the file
    const blob = new Blob([icsContent], { type: "text/calendar;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${launch.name.replace(/[^a-z0-9]/gi, "_")}.ics`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    toast.success("Calendar event downloaded!");
  };

  return (
    <button
      onClick={generateICS}
      className={`p-2 rounded-lg bg-white/5 hover:bg-white/10 border border-white/10 ${className}`}
      title="Add to Calendar"
      data-testid={`calendar-btn-${launch.id}`}
      style={{ transition: "background-color 0.2s ease" }}
    >
      <Calendar className="w-4 h-4 text-slate-400" strokeWidth={1.5} />
    </button>
  );
};
